module.exports = __webpack_public_path__ + "static/media/down-arrow-box.c7eaa062.svg";